import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-what-to-know-up',
  imports: [TranslateModule],
  templateUrl: './what-to-know-up.component.html',
  styleUrl: './what-to-know-up.component.scss'
})
export class WhatToKnowUpComponent {

}
